import options from './radio-status.component';

export default {
    selector: 'dtRadioStatus',
    options
};
